import React from 'react';
import { PropTypes } from 'prop-types';
import { NormalizeClassNameString, ToString } from '../utils';

export class PageHeader extends React.Component {
    constructor(props, ...others) {
        super(props, ...others);

        this.updatePosition = this.updatePosition.bind(this);
    }

    componentDidMount() {
        const self = this;
        self._isMounted = true;

        self.updatePosition();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate() {
        this.updatePosition();
    }

    updatePosition() {
        const self = this;

        if (self._isMounted && self.props.fixed) {
            const f = window['AdjustPageHeaderPosition'];
            if (typeof f === 'function') {
                f();
            }
        }
    }
    
    render() {
        const props = {...this.props};
        props.className = 'page-header ' + ToString(props.className);

        if (props.fixed) {
            props.className += ' is-fixed';
        }
        if (props.captionTruncate) {
            props.className += ' caption-truncate';
        }

        props.className = NormalizeClassNameString(props.className);

        const notWrappedMaxHeight = parseInt(props.notWrappedMaxHeight) || 0;
        const caption = props.caption;
        const buttons = props.buttons;
        const timeZoneInfo = props.timeZoneInfo;
        const children = props.children;

        delete props.notWrappedMaxHeight;
        delete props.caption;
        delete props.buttons;
        delete props.timeZoneInfo;
        delete props.fixed;
        delete props.captionTruncate;
        delete props.children;

        const titleProps = {
            className: 'page-header-title'
        }
        
        if (notWrappedMaxHeight > 0) {
            titleProps['data-not-wrapped-max-height'] = notWrappedMaxHeight;
        }

        return (
            <div {...props}>
                <div className="container">
                    <div {...titleProps}>
                        <div className="page-header-caption">
                            {caption}
                        </div>
                        {Boolean(buttons) &&
                            <div className="page-header-buttons">
                                <div className="form-buttons">
                                    {buttons}
                                </div>
                                {Boolean(timeZoneInfo) &&
                                    <div className="timezoneinfo">
                                        {timeZoneInfo}
                                    </div>
                                }
                            </div>
                        }
                    </div>
                    {Boolean(children) && <div>{children}</div>}
                </div>
            </div>
        )
    }
}
PageHeader.propTypes = {
    fixed: PropTypes.bool,
    captionTruncate: PropTypes.bool,
    notWrappedMaxHeight: PropTypes.number,
    caption: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    buttons: PropTypes.arrayOf(PropTypes.element),
    timeZoneInfo: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
}
PageHeader.defaultProps = {
    fixed: false,
    captionTruncate: false,
    notWrappedMaxHeight: 110, //125
}